export enum KeyAction {
    Enter = 'Enter',
  }